exports.api = env => {
    // Prefijo de las rutas de API (que viven en /api/* en el mismo server,
    // en dev y en prod). URL relativa: el browser usa el origin actual sin
    // importar el puerto/proxy.
    //
    // `production` era "" (vacío) — eso dropeaba el prefijo /api, así que en
    // prod mode (next start) las requests iban a /<ruta> en vez de /api/<ruta>
    // → pegaban en el catch-all de Next → durante el SSR, getInitialProps se
    // pedía a sí mismo → recursión → "socket hang up" (páginas colgadas, datos
    // vacíos). Debe ser "/api" igual que dev.
    let apiUrl = {
        dev: "/api",
        production: "/api"
    };

    return apiUrl[env];
};
